<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      size="small"
    >
      <el-form-item
        label="Date"
        prop="value"
      >
        <el-date-picker
          v-model="form.value"
          type="daterange"
          format="dd/MM/yyyy"
          value-format="yyyy-MM-dd"
          align="right"
          unlink-panels
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          :picker-options="pickerOptions"
          class="w-100"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pickerOptions: {
        shortcuts: [{
          text: 'Last week',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last month',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last 3 months',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      form: {
        value: null
      },
      rules: {
        value: [
          { required: true, message: 'Please select a date range', trigger: 'blur' }
        ]
      }

    }
  },
  methods: {

  }
}
</script>

<style>

</style>
